import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "aggregated-page export-page" }
const _hoisted_2 = { class: "container-page big aggregated-page__container analytics-notes__print" }
const _hoisted_3 = {
  key: 0,
  class: "aggregated-page__base-info js-aggregated-base-info"
}
const _hoisted_4 = { class: "aggregated-page__table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VedAggregatedExportButtons = _resolveComponent("VedAggregatedExportButtons")!
  const _component_PageTitle = _resolveComponent("PageTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      title: _ctx.title,
      dense: ""
    }, {
      button: _withCtx(() => [
        _createVNode(_component_VedAggregatedExportButtons, {
          config: _ctx.exportConfig,
          disabled: _ctx.getIsDisabledExportButtons
        }, null, 8, ["config", "disabled"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "filter", {}, undefined, true),
      (_ctx.$slots['base-info'])
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _renderSlot(_ctx.$slots, "base-info", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_4, [
        _renderSlot(_ctx.$slots, "table", {}, undefined, true)
      ])
    ])
  ]))
}